/**
 * Minimum character limit for email messages.
 * This ensures emails are not flagged as spam by email systems.
 */
export const MESSAGE_MIN_CHARACTER_LIMIT = 50;

// Shared so every joyJSON message composer (general, RSVP reminder, …) stays on one version. Bump here only.
export const MESSAGING_BLOCKS_SCHEMA_URI = 'https://withjoy.com/assets/public/schemas/messaging_blocks_v1.4.0.json';
